import React from 'react'
import classes from '../cartItemComponent/cartItemComponent.module.css'
import { TbPaperBag } from 'react-icons/tb'
import { increaseQuantity, decreaseQuantity, removeItem } from '../../state/redux/cartSlice'
import { useDispatch } from 'react-redux'
import { RiDeleteBin2Line } from "react-icons/ri";
import { BsCartDash } from "react-icons/bs";
import { MdOutlineAddShoppingCart } from "react-icons/md";
import { useSelector } from 'react-redux'
import { selectCartItems } from '../../state/redux/cartSlice'
import { secondaryColour } from '../../utils/colors'
import { FaCirclePlus } from "react-icons/fa6";
import { FaCircleMinus } from "react-icons/fa6";
import mealplanImage from "../../assets/images/mp.png"




function CartItem(props) {
    const dispatch = useDispatch()
    const cartItems = useSelector(selectCartItems)
    const getItems = () => {
    }

    return (
        <div className={classes.cartItemContainer}>
            <div className={classes.cartItemImage}>
                <img src={mealplanImage} alt={props.itemData.name} />
            </div>
            <div className={classes.cartItemDetailsContainer}>
                <div className={classes.cartItemHeader}>
                    <p className={classes.cartItemTitle}>{props.itemData.name}</p>
                    <button className={classes.removeButton} onClick={() => dispatch(removeItem(props.itemData.product_id))} aria-label="Remove item"><RiDeleteBin2Line/></button>
                </div>

                <div className={classes.cartItemBody}>
                    <div className={classes.priceWrap}>
                        <span className={classes.price}>GH¢ {props.itemData.cost.toFixed(2)}</span>
                        <span className={classes.subtotal}>GHC {(props.itemData.cost * props.itemData.qty).toFixed(2)}</span>
                    </div>

                    <div className={classes.controlsWrap}>
                        <button onClick={()=>dispatch(decreaseQuantity(props.itemData.product_id))} className={`${classes.qtyButton} ${classes.decrease}`} aria-label="Decrease"><FaCircleMinus/></button>
                        <div className={classes.qtyDisplay}>{props.itemData.qty}</div>
                        <button onClick={()=>dispatch(increaseQuantity(props.itemData.product_id))} className={`${classes.qtyButton} ${classes.increase}`} aria-label="Increase"><FaCirclePlus/></button>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default CartItem